"use client";

import { useSyncSegmentIdentity } from "@/hooks/useSyncSegmentIdentity";
export function SegmentIdentitySync() {
  useSyncSegmentIdentity();
  return null;
}